<template>
  <SwipeableGrid :properties="swipeableGrid" :items="images">
    <div v-for="(src, index) in images" class="item" :key="src + index">
      <img :src="src" />

      <!-- <BaseImage
          class="observe-size"
          :properties="{src: item.src, alt: item.title}"
          :key="item.id"
        /> -->
    </div>
  </SwipeableGrid>
</template>

<script>
/* Todo:

- Add support for advanced selectors

*/

import SwipeableGrid from '../SwipeableGrid/SwipeableGrid';

export default {
  name: 'InspireSlider',
  components: {SwipeableGrid},
  props: ['images'],
  data() {
    return {
      swipeableGrid: {
        columns: {
          desktop: 1,
        },
        spacing: {
          desktop: 4,
        },
        swipeable: {
          desktop: true,
        },
        dots: {
          desktop: true,
        },
        dotColor: {
          desktop: 'var(--color-primary)',
        },
        dotActiveColor: {
          desktop: 'var(--color-primaryDark)',
        },
        dotSize: {
          desktop: 5,
        },
        dotPosition: {
          desktop: -10,
        },
        arrows: {
          desktop: false,
        },
        arrowsOnHover: {
          desktop: false,
        },
        arrowSize: {
          desktop: 18,
        },
        arrowColor: {
          desktop: 'var(--color-white)',
        },
        arrowBgSize: {
          desktop: 30,
        },
        arrowBg: {
          desktop: 'var(--color-primary)',
        },
        arrowPosition: {
          desktop: 10,
          mobile: 0,
        },
      },
    };
  },
};
</script>

<style>
.popup-image-slider {
  --dot-position: 10;
  --dot-size-px: 10px;
  --dot-color: rgba(255, 255, 255, 0.547);
  --dot-active-color: white;
  --dot-size: 10;
  --arrow-size: 10;
  --arrow-bg-size: 10;
}

.popup-image-slider .grid {
  height: 100%;
}

.popup-image-slider .is-swipable:not(.swipable-initialized) .grid .item {
  display: none;
}
.popup-image-slider
  .is-swipable:not(.swipable-initialized)
  .grid
  .item:first-child {
  display: block;
}

.popup-image-slider img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>
